import Color from 'color';

export function getThemeStyle(theme) {
    if (!theme) {
        return {};
    }

    var primaryColor = theme.primaryColor;


    if (!primaryColor) {
        return {};
    }

    var backgroundColor = Color(primaryColor);

    var color = void 0;

    if (backgroundColor.isDark()) {
        color = "white";
    } else {
        color = "black";
    }

    return {
        backgroundColor: backgroundColor,
        color: color
    };
}